import { defineMessages } from 'react-intl-next';

export const i18n: {
	copyLinkTooltipLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	copiedLinkTooltipLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	successIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	copyLinkButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	copyLinkTooltipLabel: {
		id: 'copy-link-tooltip-label',
		defaultMessage: 'Copy link',
		description: 'Tooltip for the button to copy content URL',
	},
	copiedLinkTooltipLabel: {
		id: 'copied-link-tooltip-label',
		defaultMessage: 'Copied!',
		description: 'Tooltip for the button that shows content URL has been copied',
	},
	successIconLabel: {
		id: 'copy-link-success-icon-label',
		defaultMessage: 'Success icon',
		description: 'Label for the success icon used in the button to copy content URL',
	},
	copyLinkButtonLabel: {
		id: 'copy-link-button-label',
		defaultMessage: 'Copy Link',
		description: 'Label for the button that copies content URL',
	},
});
